import { useContext } from 'react';

import { useQuery } from '@tanstack/react-query';

import { AuthContext } from '@cloud-ui/contexts/AuthContext';
import { fetchLicense } from '@cloud-ui/utils/api/license';
import { createLicenseInfo, type LicenseInfo } from '@cloud-ui/utils/licenseUtils';

export interface UseLicenseResult {
  licenseInfo: LicenseInfo;
  isLoading: boolean;
  error: Error | null;
}

export const useLicense = (): UseLicenseResult => {
  const { organization } = useContext(AuthContext) || {};
  const shouldFetch = !!organization;

  const {
    data: license,
    isLoading,
    error,
  } = useQuery({
    queryKey: ['license'],
    queryFn: fetchLicense,
    enabled: shouldFetch,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
  });

  const licenseInfo = createLicenseInfo(license);

  return {
    licenseInfo,
    isLoading,
    error: error as Error | null,
  };
};
